import { CasePerson } from "./CasePerson";
import { BankData } from "./BankData";
import { Address } from "./Address";

export enum Gender {
  male = "male",
  female = "female",
  diverse = "diverse"
}

export interface Person {
  id: number;
  gender: string | Gender | null;
  familyName: string | null;
  givenName: string | null;
  telephone: string | null;
  email: string | null;
  labelType: string | null;
  casePerson: CasePerson | null;
  beaSafeId: string | null;
  bankData: BankData | null;
  residenceAddress: Address;
  "@type"?: "https://schema.org/Person";
  [additionalProperty: string]: any;
}

export function isJsonLdPerson(obj: unknown): obj is Person {
  return !!obj && typeof obj === "object" && "@type" in obj && obj["@type"] === "https://schema.org/Person";
}
